import { render, staticRenderFns } from "./WaveBg.vue?vue&type=template&id=20356222&scoped=true&"
import script from "./WaveBg.vue?vue&type=script&lang=js&"
export * from "./WaveBg.vue?vue&type=script&lang=js&"
import style0 from "./WaveBg.vue?vue&type=style&index=0&id=20356222&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20356222",
  null
  
)

export default component.exports